export const navList = [
  { text: '近期活动', key: 'sjxNewsActivity', url: '/sjx/news/activity' },
  { text: '新闻公告', key: 'sjxNewsNotice', url: '/sjx/news/notice' },
  { text: '视频中心', key: 'sjxNewsVideo', url: '/sjx/news/video' },
];
